// src/App.js
import React, { useRef, useEffect } from "react";
import ReactGA from "react-ga4";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ConocenosPage from "./components/ConocenosPage";
import Servicios from "./components/Servicios";
import Aliados from "./components/Clientes";
import NosotrosDetalle from "./components/NosotrosDetalle";

function GAListener() {
  // Simplemente envía un pageview al montar
  useEffect(() => {
    ReactGA.initialize("G-VQ12SPNX7D");
    ReactGA.send({ hitType: "pageview", page: "/" });
  }, []);
  return null;
}

function App() {
  // Creamos refs para cada sección
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);

  return (
    <>
      <GAListener />
      <Header
        screenRef1={ref1}
        screenRef2={ref2}
        screenRef3={ref3}
        screenRef4={ref4}
        screenRef5={ref5}
      />

      <main>
        <section id="section1" ref={ref1}>
          <Hero />
        </section>

        <section id="section2" ref={ref2}>
          <Servicios />
        </section>
        <section id="section3" ref={ref3}>
          <NosotrosDetalle />
        </section>
        <section id="section4" ref={ref4}>
          <Aliados />
        </section>
        <section id="section5" ref={ref5}>
          <ConocenosPage />
        </section>
      </main>
    </>
  );
}

export default App;
